export const ZEM_HISTORY_TYPE = {
  DONATION: 'donation',
  DONATION_RECEIVED: 'donationReceived',
  AVATAR_SHAPE_PURCHASE: 'avatarShapePurchase',
  EQUIPMENT_PURCHASE: 'equipmentPurchase',
  CHARGE: 'charge',
} as const;
